import React, { type ReactNode } from 'react';
import { ParameterCod } from '@/constants/parameters';

import type { Parameter } from '../../Providers/GraphqlProvider/generated';
import {
  useParameterByCodQuery,
  useParametersDefaultQuery,
} from '../../Providers/GraphqlProvider/generated';
import DynamicFavicon from './DynamicFavicon';
import LayoutConfigProvider from './LayoutConfigProvider';

interface LayoutAdminProps {
  children: ReactNode;
}

const LayoutConfig: React.FC<LayoutAdminProps> = ({ children }) => {
  const { data } = useParametersDefaultQuery();
  const { data: logoParameter } = useParameterByCodQuery({
    variables: { code: ParameterCod.Logo },
  });

  const parametersDefault = React.useMemo(() => {
    const defaults = data?.parametersDefault ?? [];
    const logo = logoParameter?.parameterByCod;
    if (logo) return [...defaults, logo];

    return defaults;
  }, [data, logoParameter]);

  return (
    <LayoutConfigProvider
      value={{
        layoutConfig: {
          parametersDefault: parametersDefault as Parameter[],
        },
      }}
    >
      <DynamicFavicon />
      {children}
    </LayoutConfigProvider>
  );
};

export default LayoutConfig;
